import { render, staticRenderFns } from "./ReviewAndPay.vue?vue&type=template&id=35482d36&scoped=true&"
import script from "./ReviewAndPay.vue?vue&type=script&lang=js&"
export * from "./ReviewAndPay.vue?vue&type=script&lang=js&"
import style0 from "./ReviewAndPay.vue?vue&type=style&index=0&id=35482d36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35482d36",
  null
  
)

export default component.exports